import type { Address } from '@sg/graphql-schema';

import { AddressType, type AvailableAddress } from '../address.config';

/**
 * Returns the available address type and name based on a list of addresses.
 * Priority: home > work > custom.
 */
export const getAvailableAddress = (
  addresses: ReadonlyArray<Pick<Partial<Address>, 'name'>>,
): AvailableAddress => {
  const isHomeTaken = addresses.some(({ name }) => name === AddressType.HOME);

  if (!isHomeTaken) return { type: AddressType.HOME, name: AddressType.HOME };

  const isWorkTaken = addresses.some(({ name }) => name === AddressType.WORK);

  if (!isWorkTaken) return { type: AddressType.WORK, name: AddressType.WORK };

  return { type: AddressType.CUSTOM, name: '' };
};
